import React from "react";

import AllJourneyConfig from "./journeyConfig/AllJourneyConfig";

const JourneyConfig = () => {
  return <AllJourneyConfig />;
};

export default JourneyConfig;
